import { render, staticRenderFns } from "./blok-table.vue?vue&type=template&id=6611a79a&scoped=true"
import script from "./blok-table.vue?vue&type=script&lang=js"
export * from "./blok-table.vue?vue&type=script&lang=js"
import style0 from "./blok-table.vue?vue&type=style&index=0&id=6611a79a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6611a79a",
  null
  
)

export default component.exports